// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.actionItemsPage__nmtJg {
  min-height: calc(100vh - 170px);
  padding: 25px;
  display: flex;
  flex-direction: column;
  gap: 25px;
}
@media (max-width: 850px) {
  .actionItemsPage__nmtJg {
    padding: 15px;
    gap: 15px;
  }
}

.actionItemsPanelContainer__POD5C {
  background: var(--tables-primary-row-surface-default);
  border: 1px solid var(--header-stroke);
}

.actionItemsPanel__ptQzZ {
  display: flex;
  padding: 15px 25px;
  justify-content: space-between;
  align-items: flex-end;
  align-self: stretch;
  border-bottom: 1px solid var(--header-stroke);
}

.searchBlock__JBLmy {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0px 25px;
  background-color: var(--header-surface);
  height: 45px;
}

.switcherBlock__MD3D6 {
  display: flex;
}

.switchItem__o3Cs4 {
  width: 35px;
  height: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: var(--segments-chips-toggle-surface-default);
  fill: var(--segments-chips-toggle-text-default);
  cursor: pointer;
}

.switchItemActive__MxFyK {
  background-color: var(--segments-chips-toggle-surface-active);
}
.switchItemActive__MxFyK > svg > path {
  fill: var(--segments-chips-toggle-text-active);
}
.switchItemActive__MxFyK .searchIcon__cRRqc > path {
  fill: var(--segments-chips-toggle-text-active);
  stroke: var(--segments-chips-toggle-text-active);
}

.actionItemsTable__mPXUe {
  box-shadow: var(--basic-box-shadow);
}

.actionItemsPanelBtns__q3RHF {
  display: flex;
  gap: 20px;
  text-wrap: nowrap;
}

.actionItemsPanelFilter__DuJbp {
  display: flex;
  gap: 10px;
}

.actionItemsPanelItemReset__Uc_H4 {
  width: 16px;
  display: flex;
  align-items: center;
  align-self: flex-end;
}

.additionalFiltersMenu__QjV8z {
  display: none;
}
@media (max-width: 1200px) {
  .additionalFiltersMenu__QjV8z {
    display: flex;
    align-items: center;
    align-self: flex-end;
  }
}

.iconContainer__G_YSJ {
  width: 35px;
  height: 35px;
  border-radius: 2px;
  background: var(--segments-chips-toggle-surface-default);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: relative;
}

.active__NdIuC {
  background: var(--segments-chips-toggle-surface-active);
}

.activeExtraFiltersIconDot__X3gxs {
  display: block;
}
.activeExtraFiltersIconDot__X3gxs:after {
  content: "";
  position: absolute;
  top: -2px;
  right: -2px;
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: var(--buttons-text-secondary);
}

.textTooltip__MdiIL {
  padding: 8px !important;
  opacity: 1 !important;
  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));
  border-radius: 4px !important;
  text-align: left !important;
}`, "",{"version":3,"sources":["webpack://./../src/pages/ActionItems/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,+BAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAzEF;AA2EE;EAPF;IAQI,aAAA;IACA,SAAA;EAxEF;AACF;;AA2EA;EACE,qDAAA;EACA,sCAAA;AAxEF;;AA2EA;EACE,aAAA;EACA,kBAAA;EACA,8BAAA;EACA,qBAAA;EACA,mBAAA;EACA,6CAAA;AAxEF;;AA2EA;EACE,WAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,iBAAA;EACA,uCAAA;EACA,YAAA;AAxEF;;AA2EA;EACE,aAAA;AAxEF;;AA2EA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,8DAAA;EACA,+CAAA;EACA,eAAA;AAxEF;;AA2EA;EACE,6DAAA;AAxEF;AAyEE;EACE,8CAAA;AAvEJ;AA2EI;EACE,8CAAA;EACA,gDAAA;AAzEN;;AA8EA;EACE,mCAAA;AA3EF;;AA8EA;EACE,aAAA;EACA,SAAA;EACA,iBAAA;AA3EF;;AA8EA;EACE,aAAA;EACA,SAAA;AA3EF;;AA8EA;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,oBAAA;AA3EF;;AA8EA;EACE,aAAA;AA3EF;AA6EE;EAHF;IAII,aAAA;IACA,mBAAA;IACA,oBAAA;EA1EF;AACF;;AA6EA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,wDAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,kBAAA;AA1EF;;AA6EA;EACE,uDAAA;AA1EF;;AA6EA;EACE,cAAA;AA1EF;AA4EE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,yCAAA;AA1EJ;;AA8EA;EAjJE,uBAAA;EACA,qBAAA;EACA,mDAAA;EACA,6BAAA;EACA,2BAAA;AAuEF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.actionItemsPage {\n  min-height: calc(100vh - 170px);\n  padding: 25px;\n  display: flex;\n  flex-direction: column;\n  gap: 25px;\n\n  @media (max-width: 850px) {\n    padding: 15px;\n    gap: 15px;\n  }\n}\n\n.actionItemsPanelContainer {\n  background: var(--tables-primary-row-surface-default);\n  border: 1px solid var(--header-stroke);\n}\n\n.actionItemsPanel {\n  display: flex;\n  padding: 15px 25px;\n  justify-content: space-between;\n  align-items: flex-end;\n  align-self: stretch;\n  border-bottom: 1px solid var(--header-stroke);\n}\n\n.searchBlock {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0px 25px;\n  background-color: var(--header-surface);\n  height: 45px;\n}\n\n.switcherBlock {\n  display: flex;\n}\n\n.switchItem {\n  width: 35px;\n  height: 35px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: var(--segments-chips-toggle-surface-default);\n  fill: var(--segments-chips-toggle-text-default);\n  cursor: pointer;\n}\n\n.switchItemActive {\n  background-color: var(--segments-chips-toggle-surface-active);\n  & > svg > path {\n    fill: var(--segments-chips-toggle-text-active);\n  }\n\n  .searchIcon {\n    & > path {\n      fill: var(--segments-chips-toggle-text-active);\n      stroke: var(--segments-chips-toggle-text-active);\n    }\n  }\n}\n\n.actionItemsTable {\n  box-shadow: var(--basic-box-shadow);\n}\n\n.actionItemsPanelBtns {\n  display: flex;\n  gap: 20px;\n  text-wrap: nowrap;\n}\n\n.actionItemsPanelFilter {\n  display: flex;\n  gap: 10px;\n}\n\n.actionItemsPanelItemReset {\n  width: 16px;\n  display: flex;\n  align-items: center;\n  align-self: flex-end;\n}\n\n.additionalFiltersMenu {\n  display: none;\n\n  @media (max-width: 1200px) {\n    display: flex;\n    align-items: center;\n    align-self: flex-end;\n  }\n}\n\n.iconContainer {\n  width: 35px;\n  height: 35px;\n  border-radius: 2px;\n  background: var(--segments-chips-toggle-surface-default);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  position: relative;\n}\n\n.active {\n  background: var(--segments-chips-toggle-surface-active);\n}\n\n.activeExtraFiltersIconDot {\n  display: block;\n\n  &:after {\n    content: '';\n    position: absolute;\n    top: -2px;\n    right: -2px;\n    width: 5px;\n    height: 5px;\n    border-radius: 50%;\n    background: var(--buttons-text-secondary);\n  }\n}\n\n.textTooltip {\n  @include tooltip;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"actionItemsPage": `actionItemsPage__nmtJg`,
	"actionItemsPanelContainer": `actionItemsPanelContainer__POD5C`,
	"actionItemsPanel": `actionItemsPanel__ptQzZ`,
	"searchBlock": `searchBlock__JBLmy`,
	"switcherBlock": `switcherBlock__MD3D6`,
	"switchItem": `switchItem__o3Cs4`,
	"switchItemActive": `switchItemActive__MxFyK`,
	"searchIcon": `searchIcon__cRRqc`,
	"actionItemsTable": `actionItemsTable__mPXUe`,
	"actionItemsPanelBtns": `actionItemsPanelBtns__q3RHF`,
	"actionItemsPanelFilter": `actionItemsPanelFilter__DuJbp`,
	"actionItemsPanelItemReset": `actionItemsPanelItemReset__Uc_H4`,
	"additionalFiltersMenu": `additionalFiltersMenu__QjV8z`,
	"iconContainer": `iconContainer__G_YSJ`,
	"active": `active__NdIuC`,
	"activeExtraFiltersIconDot": `activeExtraFiltersIconDot__X3gxs`,
	"textTooltip": `textTooltip__MdiIL`
};
module.exports = ___CSS_LOADER_EXPORT___;
